import { render, staticRenderFns } from "./loading_button.vue?vue&type=template&id=b5a20890&"
import script from "./loading_button.vue?vue&type=script&lang=js&"
export * from "./loading_button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "loading_button.vue"
export default component.exports